/* eslint-disable react/require-default-props */
import React, { Suspense } from 'react';

import HtmlWrapper from '../html-wrapper/html-wrapper';

const MatchReportsDetailWrapper = React.lazy(() => import('./match-reports-detail'));

export interface IDynamicMatchReportsDetail {
  model: any;
  query?: {};
  children?: React.ReactNode;
  live?: boolean;
}

// TODO: ADD useService if component need to do Query or Subs
const DynamicMatchReportsDetail = ({
  /* istanbul ignore next: default value */ query = {},
  /* istanbul ignore next: default value */ model = {},
  /* istanbul ignore next: default value */ children = null,
  /* istanbul ignore next: default value */ live = false,
}: IDynamicMatchReportsDetail) => {
  return (
    <Suspense fallback={<HtmlWrapper html={children} />}>
      <MatchReportsDetailWrapper live={live} query={query} initialModel={model} />
    </Suspense>
  );
};

export default DynamicMatchReportsDetail;
